import React from 'react'
import { Route, BrowserRouter as Router, Routes} from 'react-router-dom';
import Navbar from './components/Navbar';
import { Home, About, Resume, Projects, Contact } from './pages';

const App = () => {
  return (
    <main className='bg-slate-300/20 h-screen'>
        <Router>
            <Navbar />
            <Routes>
                <Route path ="/" element = {<Home/>} />
                <Route path ="/about" element = {<About/>} />
                <Route path ="/resume" element = {<Resume/>} />
                <Route path ="/projects" element = {<Projects/>} />
                <Route path ="/contact" element = {<Contact/>} />
            </Routes>
        </Router>
    </main>
  )
}

export default App